<template>
    <div class="deteil">
        <el-card class="box-card">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/BusManage-Detail' }">商家管理</el-breadcrumb-item>
                <el-breadcrumb-item>列表</el-breadcrumb-item>
            </el-breadcrumb>
        </el-card>
        <el-row style="margin-top:20px;">
            <el-col :span="24">
                <el-card class="box-card">
                    <el-row :gutter="15">
                        <el-col :span="1.2">
                            <div class="grid-content bg-purple">
                                <span>门店名称:</span>
                            </div>
                        </el-col>
                        <el-col :span="5"
                            ><div class="grid-content bg-purple">
                                <el-input v-model="searchInfo.merchantName" placeholder="请输入门店名称" clearable></el-input></div
                        ></el-col>
                        <el-col :span="10">
                            <el-button type="primary" icon="el-icon-search" @click="Search()">查询</el-button>
                            <el-button type="primary" icon="el-icon-plus" @click="$refs.add.openDialog()">新增</el-button>
                        </el-col>
                    </el-row>
                    <el-table :data="tableData" style="width: 100%" border>
                        <el-table-column :resizable="false" type="index" label="序号" width="50">
                            <template slot-scope="scope">{{ scope.$index + 1 + searchInfo.pageSize * (searchInfo.pageNum - 1) }}</template>
                        </el-table-column>
                        <el-table-column
                            prop="merchantType"
                            label="商家分类"
                            :resizable="false"
                            align="center"
                            width="100"
                        ></el-table-column>
                        <el-table-column :resizable="false" prop="merchantName" label="门店名称" align="center">
                            <template slot-scope="scope">
                                <a class="deltitle" @click="goDetail(scope.row)">
                                    {{ scope.row.clothesName }}
                                </a>
                            </template>
                        </el-table-column>
                        <el-table-column prop="merchantServer" label="服务名称" :resizable="false" align="center"></el-table-column>
                        <el-table-column
                            prop="merchantTelephone"
                            label="联系电话"
                            :resizable="false"
                            align="center"
                            width="150"
                        ></el-table-column>
                        <el-table-column prop="createTime" label="创建时间" :resizable="false" align="center" width="200">
                            <template slot-scope="scope">
                                <span>{{ scope.row.createTime | moment('YYYY-MM-DD HH:mm:ss') }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" :resizable="false" align="center">
                            <template slot-scope="scope">
                                <el-button type="text" size="small" @click="edit(scope.row.id)">修改</el-button>
                                <el-button @click="delectModal(scope.row)" type="text" size="small">删除</el-button>
                                <el-button @click="couponModal(scope.row)" type="text" size="small">优惠券</el-button>
                                <el-button @click="swiperModal(scope.row)" type="text" size="small">轮播图</el-button>
                                <el-button @click="subject(scope.row)" type="text" size="small">专题</el-button>
                                <el-button v-if="scope.row.isRecommend == '0'" @click="hotModal(scope.row)" type="text" size="small"
                                    >推荐</el-button
                                >
                                <el-button v-if="scope.row.isRecommend == '1'" @click="unHotModal(scope.row)" type="text" size="small"
                                    >取消推荐</el-button
                                >
                                <el-button v-if="loginName == 'admin'" @click="modify(scope.row)" type="text" size="small"
                                    >修改商户密码</el-button
                                >
                            </template>
                        </el-table-column>
                    </el-table>
                    <!-- 分页区域 -->
                    <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="searchInfo.pageNum"
                        :page-size="searchInfo.pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                    ></el-pagination>
                </el-card>
            </el-col>
        </el-row>
        <!-- 弹框 -->
        <!-- <el-dialog
            title="新增商家"
            :visible.sync="addDialogFormVisible"
            :before-close="handleClose"
            width="40%"
            :close-on-click-modal="false"
        >
            <add ref="add" @dialog="dialogForm"></add>
        </el-dialog> -->
        <add ref="add" @getSysInfoList="getSysInfoList"></add>
        <edit ref="edit" @getSysInfoList="getSysInfoList"></edit>
        <el-dialog title="修改密码" :visible.sync="dialogVisible" width="30%" :before-close="handleClosePwd" :close-on-click-modal="false">
            <el-form :model="pwdForm" :rules="rules" ref="pwdForm" label-width="100px" class="demo-ruleForm">
                <el-form-item label="新密码" prop="newPwd">
                    <el-input :type="pwdType2" v-model="pwdForm.newPwd" placeholder="请输入新密码">
                        <i slot="suffix" class="el-input__icon el-icon-view" :class="{ pwd: isPwd2 }" @click="handleToPwd2"></i>
                    </el-input>
                </el-form-item>
                <el-form-item label="确认新密码" prop="confirmNewPwd">
                    <el-input :type="pwdType3" v-model="pwdForm.confirmNewPwd" placeholder="请再次输入新密码">
                        <i slot="suffix" class="el-input__icon el-icon-view" :class="{ pwd: isPwd3 }" @click="handleToPwd3"></i>
                    </el-input>
                </el-form-item>
            </el-form>
            <div class="dialog-footer">
                <el-button type="info" @click="handleClosePwd">取 消</el-button>
                <el-button type="primary" @click="changePwd">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import add from './detailChildren/add.vue';
import edit from './detailChildren/edit.vue';
export default {
    data() {
        var validatePass = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请输入密码'));
            } else if (value.length < 5 || value.length > 16) {
                callback(new Error('密码长度为6-16位'));
            } else {
                var reg = new RegExp(/^(?![^a-zA-Z]+$)(?!\D+$)/);
                if (!reg.test(value)) {
                    callback(new Error('密码仅支持字母、数字的组合'));
                } else {
                    callback();
                }
            }
        };
        const validatePass1 = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请再次输入密码'));
            }else if(value.length < 5 || value.length > 16){
               callback(new Error('密码长度为6-16位'));
            } else if (value !== this.pwdForm.newPwd) {
                callback(new Error('两次输入密码不一致!'));
            }else {
                var reg = new RegExp(/^(?![^a-zA-Z]+$)(?!\D+$)/);
                if (!reg.test(value)) {
                    callback(new Error('密码仅支持字母、数字的组合'));
                } else {
                    callback();
                }
            }
        };
        return {
            searchInput: '',
            // 查询参数
            searchInfo: {
                // 默认请求第一页
                pageNum: 1,
                // 默认请求10条数据
                pageSize: 10,
                merchantName: '' //商家名称
            },
            // 日期
            date: null,
            loginName: '',
            // 数据列表
            tableData: [],
            // 数据总数
            total: 0,
            // 下拉框的数据列表
            moduleList: [],
            editData: '',
            addDialogFormVisible: false, //新增
            editDialogFormVisible: false, //修改
            dialogVisible: false,
            pwdType2: 'password',
            isPwd2: false,
            pwdType3: 'password',
            isPwd3: false,
            pwdForm: {
                // 新密码
                newPwd: '',
                // 确认新密码
                confirmNewPwd: ''
            },
            rules: {
                newPwd: [
                    { required: true, message: '请输入新密码', trigger: 'blur' },
                    { validator: validatePass, trigger: 'blur' }
                ],
                confirmNewPwd: [
                    { required: true, message: '请再次输入密码', trigger: 'blur' },
                    { validator: validatePass1, trigger: 'blur' }
                ]
            },
            pwdId: '' //商户id
        };
    },
    components: { add, edit },
    created() {
        // 获取数据列表
        this.getSysInfoList();
        this.loginName = window.sessionStorage.getItem('loginName');
    },
    methods: {
        Search() {
            this.searchInfo.pageNum = 1;
            this.getSysInfoList();
        },
        async getSysInfoList() {
            const res = await this.$axios.post('manage/cloth/search', this.searchInfo);
            console.log(res);
            if (res.data.code == 0) {
                this.tableData = res.data.data;
                this.total = res.data.total;
            }
            // console.log(res);
        },

        edit(data) {
            let that = this;
            console.log(this.editData);
            that.$refs.edit.getMerchantInfo(data)
        },
        handleSizeChange(pageSize) {
            console.log(pageSize);
            this.pageNum = 1;
            this.searchInfo.pageSize = pageSize;
            this.getSysInfoList();
        },

        handleCurrentChange(pageNum) {
            console.log(pageNum);
            this.searchInfo.pageNum = pageNum;
            this.getSysInfoList();
        },

        handleToSearch() {
            this.searchInfo.pageNum = 1;
            this.getSysInfoList();
        },
        //删除
        delectModal(data) {
            console.log(data);

            this.$confirm('您确定要删除吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$axios
                    .post('merchant/delete', { id: data.id })
                    .then(res => {
                        if (res.data.code == 0) {
                            this.$message.success('删除成功');
                            this.getSysInfoList();
                        } else {
                            this.$message.error(res.data.msg);
                        }
                    })
                    .catch(() => {
                        this.getSysInfoList();
                    });
            });
        },
        //优惠券
        couponModal(data) {
            let that=this
            console.log(data);

            that.$router.push({ path: '/BusManage-Coupon', query: { id: data.id } });
        },
        //轮播图
        swiperModal(data) {
            let that=this
            that.$router.push({ path: '/BusManage-swiper', query: { id: data.id } });
        },
        //专题
        subject(data) {
              let that=this
            that.$router.push({ path: '/BusManage-subject', query: { id: data.id } });
        },
        //推荐商家
        hotModal(data) {
            this.$axios
                .post('merchant/toRecommend', {
                    id: data.id
                })
                .then(res => {
                    console.log(res);
                    if (res.data.code == 0) {
                        this.$message.success('推荐成功');
                        this.getSysInfoList();
                    } else {
                        this.$message.error(res.data.data);
                    }
                });
        },
        //取消推荐
        unHotModal(data) {
            this.$axios
                .post('merchant/toUnRecommend', {
                    id: data.id
                })
                .then(res => {
                    console.log(res);
                    if (res.data.code == 0) {
                        this.$message.success('取消推荐成功');
                        this.getSysInfoList();
                    } else {
                        this.$message.error(res.data.data);
                    }
                });
        },
        goDetail(data) {
            let that=this
            console.log(data.id);
            that.$router.push({ path: '/Detail', query: { id: data.id } });
        },
        //修改密码
        modify(data) {
            this.dialogVisible = true;
            this.pwdId = data.id;
        },
        // 修改密码
        changePwd() {
            let that = this;
            that.$refs.pwdForm.validate(async valid => {
                if (valid) {
                    const res = await this.$axios.post('/merchant/updatePassword ', {
                        id: that.pwdId,
                        newPassword: that.pwdForm.newPwd
                    });
                    if (res.data.code == 0) {
                        this.$message.success(`${res.data.data}`);
                        this.isPwd1 = false;
                        this.pwdType1 = 'password';
                        this.isPwd2 = false;
                        this.pwdType2 = 'password';
                        this.isPwd3 = false;
                        this.pwdType3 = 'password';
                        this.handleClosePwd();
                        // sessionStorage.clear();
                        // this.$router.push('/login');
                    } else {
                        this.$message.error(`${res.data.data}`);
                        this.handleClosePwd();
                    }
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        // dialog关闭事件
        handleClosePwd() {
            this.dialogVisible = false;
            this.isPwd2 = false;
            this.pwdType2 = 'password';
            this.isPwd3 = false;
            this.pwdType3 = 'password';
            this.$refs.pwdForm.resetFields();
        },
        // 显示隐藏密码
        handleToPwd2() {
            this.isPwd2 = !this.isPwd2;
            if (this.isPwd2) {
                this.pwdType2 = 'text';
            } else {
                this.pwdType2 = 'password';
            }
        },
        handleToPwd3() {
            this.isPwd3 = !this.isPwd3;
            if (this.isPwd3) {
                this.pwdType3 = 'text';
            } else {
                this.pwdType3 = 'password';
            }
        }
    }
};
</script>
<style lang="less" scoped>
.el-table {
    margin-top: 20px;
}
.el-pagination {
    margin-top: 20px;
    text-align: center;
}
.deltitle:hover {
    cursor: pointer;
    text-decoration: underline;
}
.deltitle {
    color: #66b1ff;
}
.dialog-footer {
    text-align: right;
}
.pwd {
    color: #409eff;
}
</style>
